import React, { useEffect, useState } from "react";
import TableAction from "../../TableAction";
import { Input, Modal, Select, Table } from "antd";
import {
  useAddInput,
  useAddInputToOrder,
  useInputListByCategory,
  useInputListByOrderId,
} from "../../../api/input";
import { useInputSales } from "../../../api/agro_dealer";
// import { useAddInputPrice } from '../../../api/input_price';

const columns = [
  {
    title: "Input name",
    dataIndex: "inputName",
  },
  {
    title: "Quantity",
    dataIndex: "quantity",
    render: (text: string, record: any) => {
      return (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            fontWeight: 400,
            fontSize: 15,
            gap: 12,
          }}
        >
          {record.quantity} {record.measurementUnit}
        </div>
      );
    },
  },
  {
    title: "Unit price (ETB)",
    dataIndex: "unitPrice",
  },
  {
    title: "Total price (ETB)",
    dataIndex: "totalPrice",
  },
  {
    title: "Redeemed by",
    render: (text: string, record: any) => {
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            fontWeight: 400,
            fontSize: 15,
            gap: 12,
          }}
        >
          <div>{record.fullName}</div>
          <div>{record.phoneNo}</div>
        </div>
      );
    },
  },
];

const InputSalesPage = () => {
  const [searchText, setSearchText] = useState("");
  const [tableData, setTableData] = useState<any[]>([]);
  const [inputSales, setInputSales] = useState<any[]>([]);

  const { data, isLoading, refetch } = useInputSales();

  useEffect(() => {
    if (inputSales) {
      if (searchText) {
        const _data = inputSales.filter(
          (item: any) =>
            item.inputName?.toLowerCase().includes(searchText.toLowerCase()) ||
            item.quantity
              ?.toString()
              .toLowerCase()
              .includes(searchText.toLowerCase()) ||
            item.measurementUnit
              ?.toLowerCase()
              .includes(searchText.toLowerCase()) ||
            item.unitPrice
              ?.toString()
              .toLowerCase()
              .includes(searchText.toLowerCase()) ||
            item.totalPrice
              ?.toString()
              .toLowerCase()
              .includes(searchText.toLowerCase()) ||
            item.fullName
              ?.toString()
              .toLowerCase()
              .includes(searchText.toLowerCase()) ||
            item.phoneNo
              ?.toString()
              .toLowerCase()
              .includes(searchText.toLowerCase()),
        );

        setTableData(_data);
      } else {
        setTableData(inputSales);
      }
    }
  }, [inputSales, searchText]);

  useEffect(() => {
    if (data && data.data && data.data.data) {
      const _data = data.data.data.map((item: any) => {
        return {
          id: item.id,
          inputName: item.redemption.entitlementDetail.input.inputName,
          quantity: item.redemption.entitlementDetail.quantity,
          measurementUnit:
            item.redemption.entitlementDetail.input.measurementUnit,
          unitPrice: item.redemption.entitlementDetail.unitPrice,
          totalPrice:
            item.redemption.entitlementDetail.unitPrice *
            item.redemption.entitlementDetail.quantity,
          fullName: item.redemption.redeemedBy.fullName,
          phoneNo: item.redemption.redeemedBy.phoneNo,
        };
      });

      setInputSales(_data);
    }
  }, [data]);

  return (
    <div
      style={{
        borderRadius: 8.5,
        marginTop: 25,
        paddingLeft: 50,
        paddingRight: 50,
        paddingTop: 22,
        backgroundColor: "white",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          height: 80,
          backgroundColor: "#EEF3F8",
          borderRadius: 8.4,
          marginBottom: 12,
        }}
      >
        <TableAction setSearchText={setSearchText} />
      </div>
      <Table dataSource={tableData} columns={columns} loading={isLoading} />
    </div>
  );
};

export default InputSalesPage;
